import cn from 'clsx';
import {useReservation} from 'context/reservation';
import {useCustomTheme} from 'context/customTheme';
import chekinLogoIcon from 'assets/icons/accept-icon.svg?no-inline';
import {Header, LogoAndTitle, HeaderImg, HeaderTitle} from './styled';

type Props = {
  onClickLogo?: () => void;
  className?: string;
};

function AuthPageHeader({onClickLogo, className}: Props) {
  const {housing} = useReservation();
  const {data: template} = useCustomTheme();
  const logo = template?.navigation_title_logo ?? chekinLogoIcon;

  return (
    <Header className={cn('auth-page__header', className)}>
      <LogoAndTitle onClick={onClickLogo}>
        <HeaderImg src={logo} width={48} height={48} />
        <HeaderTitle>{housing?.name}</HeaderTitle>
      </LogoAndTitle>
    </Header>
  );
}

export {AuthPageHeader};
